export default __webpack_public_path__ + "static/media/bg6.50938d5a.png";